module.exports = __webpack_public_path__ + "img/icon-number-two.2f8acdfd.svg";